import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import CommonSelect from "../../../../core/common/commonSelect";
import {
  allClass,
  names,
  status,
} from "../../../../core/common/selectoption/selectoption";
import TeacherModal from "../teacherModal";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import Table from "../../../../core/common/dataTable/index";
import { teacherLists } from "../../../../core/data/json/teacherlist";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import TooltipOption from "../../../../core/common/tooltipOption";
import UserService from "../../../network/services/UserService";
import { getUser } from "../../../network/auth/Auth";
import { Modal, Toast } from 'react-bootstrap'


const TeacherList = () => {
  const routes = all_routes;
  const data = teacherLists;


  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);


  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  interface TeacherData {
    id: any;
    partner_id: any;
    first_name: any;
    last_name: any;
    birth_date: any;
    blood_group: any;
    gender: any;
    nationality: any;
    main_department_id: any;
    allowed_department_ids: any;
    active: any;
    session_ids: any;
    operating_branch_id: any;
    faculty_subject_ids: any;
    company_id: any

  }
  interface Option {
    id: any;
    name: any;
  }
  const [isLoading, setIsLoading] = useState(false);
  const [teachers, setTeachers] = useState<TeacherData[]>([]);
  const [branch, setBranch] = useState<any>();
  const branches = useState<any>([]);



  const fetchData = async (branch_id: any, company_id: any, item: any) => {
    if (item) {
      setBranch(item.name);
    }
    UserService.getTeachersByBranchAndComapny(branch_id, company_id, (response: any) => {
      if (response?.data && response?.success) {
        setTeachers(response.data);
      } else {
        setTeachers([]);
      }
    });
  };


  const fetchDataInit = async (company_id: any) => {
    setBranch('All');
    setIsLoading(true)
    await UserService.getTeachersByBranchAndComapnyAll(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setIsLoading(false)

        setTeachers(response.data);

      }
    })

  };



  const [bookings, setBookings] = useState<any>([]);
  const getAllBookings = () => {
    console.log("users")
    console.log('goooooo--------------------------')

    UserService.getBookings((response: any) => {

      if (response?.success === true) {
        setBookings(response.data)
      }
    })
  }

  useEffect(() => {
    getAllBookings()
  }, [])


  const recordDescriptions: { [key: number]: any } = {
    1: 'Tricycle',
    2: 'Dyna',
    3: 'Dyna',
    4: 'Fourgon',
    5: 'Fourgon',
    6: 'Remorques',
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string) => (
        <Link to={routes.teacherDetails} className="link-primary">
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) => a.id.length - b.id.length,
    },

    {
      title: "Pickup place name",
      dataIndex: "pickup_place_name",
      render: (record: any) => (
        <div className="d-flex flex-wrap gap-2">

          <span className="badge rounded-pill bg-success text-white mr-2">
            {record}
          </span>

        </div>
      ),
      sorter: (a: any, b: any) => a.pickup_place_name.length - b.pickup_place_name.length,
    },
    {
      title: "Dropoff place name",
      dataIndex: "dropoff_place_name",
      render: (record: any) => (
        <div className="d-flex flex-wrap gap-2">

          <span className="badge rounded-pill bg-warning text-white mr-2">
            {record}
          </span>

        </div>
      ),
      sorter: (a: any, b: any) => a.dropoff_place_name.length - b.dropoff_place_name.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (record: any) => (
        <div className="d-flex flex-wrap gap-2">

          <span className="badge rounded-pill bg-light text-dark mr-2">
            {record}
          </span>

        </div>
      ),
      sorter: (a: any, b: any) =>
        a.status.length - b.status.length,
    },
    {
      title: "price",
      dataIndex: "prix",
      render: (record: any) => (
        <>

          <span className="">

            {record}
          </span>

        </>
      ),
      sorter: (a: any, b: any) =>
        a.prix.length - b.prix.length,
    },
    {
      title: "urgence",
      dataIndex: "urgence",
      render: (record: any) => (
        <span className="">

          {record}
        </span>
      ),
      sorter: (a: any, b: any) =>
        a.urgence.length - b.urgence.length,
    },
    {
      title: "Vehicle",
      dataIndex: "vehicle_id",
      render: (record: any) => (
        <span className="">

          {recordDescriptions[record] || null}
        </span>
      ),
      sorter: (a: any, b: any) =>
        a.urgence.length - b.urgence.length,
    },

    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to={routes.teacherDetails}
                  >
                    <i className="ti ti-menu me-2" />
                    View Teacher
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to={routes.editTeacher}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#login_detail"
                  >
                    <i className="ti ti-lock me-2" />
                    Login Details
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item rounded-1" to="#">
                    <i className="ti ti-toggle-right me-2" />
                    Disable
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Offers List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Peoples</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Offers List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <a

                  className="btn btn-primary d-flex align-items-center"
                  onClick={handleShow}
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Offers
                </a>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Students List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Offers List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width "
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom pb-0">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Name</label>
                              <CommonSelect
                                className="select"
                                options={names}
                                defaultValue={names[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              <CommonSelect
                                className="select"
                                options={allClass}
                                defaultValue={allClass[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={status}
                                defaultValue={status[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                  <Link
                    to="#"
                    className="active btn btn-icon btn-sm me-1 primary-hover"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={routes.teacherGrid}
                    className="btn btn-icon btn-sm bg-light primary-hover"
                  >
                    <i className="ti ti-grid-dots" />
                  </Link>
                </div>
                <div className="dropdown mb-3">
                  <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="ti ti-sort-ascending-2 me-2" />
                    {branch}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li >
                      <a className="dropdown-item rounded-1" onClick={() => fetchDataInit(getUser()?.company_ids[0]?.id)}>
                        All
                      </a>
                    </li>
                    {branches?.map((item: any) => (
                      <li key={item.id}>
                        <a className="dropdown-item rounded-1" onClick={() => fetchData(item.id, getUser()?.company_ids[0]?.id, item)}>
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}

              <Table dataSource={bookings} columns={columns} Selection={true} />
              {/* /Student List */}
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      <TeacherModal />


      <Modal show={showModal} onHide={handleClose} >
        <Modal.Header >
          <Modal.Title>Add Teacher</Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">First Name</label>
                    <input type="text" className="form-control" placeholder="First Name" name="first_name"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Last Name</label>
                    <input type="text" className="form-control" name="last_name" placeholder="Last Name"
                    />

                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control" name="email"
                      placeholder="Email" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Phone</label>
                    <input type="number" className="form-control" name="phone" placeholder="Phone"
                    />

                  </div>
                  <div className="mb-3">
                    <label className="form-label">Birth Date</label>
                    <input type="date" className="form-control" name="birth_date" placeholder="Birth date" />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Gender</label>
                    <select

                      className="select react-select form-control"
                      name="gender"

                    >
                      <option >Select Gender</option>

                      <option value="m">Male</option>
                      <option value="f">Female</option>


                    </select>
                  </div>






                </div>
                <div className="col-md-6">





                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span
                className="btn btn-light me-2"
                onClick={handleClose}
              >
                Cancel
              </span>
              <Link to="#" className="btn btn-primary"  >


                Add Teacher


              </Link>
            </div>
          </form>
        </Modal.Body>

      </Modal>
    </>
  );
};

export default TeacherList;
